import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';


export const AuthRoutes = ({ component: Component, ...rest }) => {

    const auth  = useSelector((state) => state.auth);

    return (
        
        <Route {...rest} render={props => {
            if (auth.isAuthenticated) {
                // not logged in so redirect to login page with the return url
                return <Redirect to={{ pathname: '/admin/searchLeads', state: { from: props.location } }} />
            }
           
            // authorised so return component
            return <Component {...props} />
        }} />

       
    )
}

export default AuthRoutes;